import * as localforage from "localforage";
import axios from "axios";

export const getDriveStorageFilesAPI = async (
  orderByColumn,
  orderByDesc,
  page,
  record,
  parent_id,
  company_id
) => {

  let response = await axios({
    url: `/api/v2/drive/file/drive-storage-files`,
    method: "GET",
    params: {
      order_by_column: orderByColumn,
      order_by_desc: orderByDesc,
      page: page,
      record: record,
      parent_id,
      company_id
    }
  });

  return response.data;
};
